export default function WorkItemEditModel(
  preferredAppointmentDate,
  preferredAppointmentSlot,
  preferredAppointmentSlotTitle,
  appointmentConfirmed,
  appointmentConfirmedTitle,
  workitemcategoryid,
  workitemcategoryname,
  workitemtemplateid,
  workitemtemplateref,
  jobSpecificAccessNotes,
  projectId,
  projectName,
  redFlag,
  propertyAccessNotes,
  workItemNotes,
  expectedParts,
  faultyAssets
) {
  return {
    id: null,
    workitemcategoryid,
    workitemcategoryname,
    preferredAppointmentDate,
    preferredAppointmentSlot,
    preferredAppointmentSlotTitle,
    appointmentConfirmed,
    appointmentConfirmedTitle,
    jobSpecificAccessNotes,
    isCompleted: false,
    workitemtemplateid,
    workitemtemplateref,
    projectId,
    projectName,
    disconnectelectricity: false,
    disconnectheat: false,
    disconnecthotwater: false,
    reconnectelectricity: false,
    reconnectheat: false,
    reconnecthotwater: false,
    redflag: redFlag,
    propertyaccessnotes: propertyAccessNotes,
    workItemNotes,
    expectedParts,
    faultyAssets,
  };
}
